import PropTypes from "prop-types";
// form
import { useFormContext, Controller } from "react-hook-form";
// ----------------------------------------------------------------------
import "react-phone-number-input/style.css";
import { FormControl, TextField } from "@mui/material";
import { DatePicker } from "@mui/x-date-pickers";

RHFCalendarField.propTypes = {
  name: PropTypes.string,
  helperText: PropTypes.node,
};

export default function RHFCalendarField({ name, helperText, label, sx, ...other }) {
  const { control } = useFormContext();

  return (
    <Controller
      name={name}
      control={control}
      render={({ field, fieldState: { error } }) => (
        <FormControl
          sx={{
            display: "inline-flex",
            flexDirection: "column",
            position: "relative",
            minWidth: "0",
            padding: "0",
            margin: "0",
            border: "0",
            verticalAlign: "top",
            width: "100%",
          }}
        >
          <DatePicker
            {...field}
            value={field.value || null}
            label={label}
            inputFormat="dd/MM/yyyy"
            renderInput={(params) => (
              <TextField
                fullWidth
                value={field.value ? params.value : ""}
                {...params}
                error={!!error}
                helperText={error?.message}
              />
            )}
          />
        </FormControl>
      )}
    />
  );
}
